import { Filters } from '@/types/table';

const TABLE_FILTERS: Filters[] = [
  {
    selector: 'memberName',
    value: ''
  },
  {
    selector: 'entity',
    value: ''
  },
  {
    selector: 'role',
    value: ''
  }
];

export default TABLE_FILTERS;
